export default {

    cancel: "取消",
    "confirm": "確認",
  
  
    menu: {
      about: "關於雲呈",
      domainName: "區塊鏈域名",
      login: "登入",
      jian: "簡",
  
      name: "雲呈",
      strategy: "實用攻略",
      case: "成功案例",
      insight: "專家見解",
      finance: "財科快訊",
      column: "CEO專欄",
  
    },
  
  
    home: {
      slogan: "區塊在握",
      slogan2: "鏈接未來",
      introduction: "雲呈 是香港領先區塊鏈及網絡安全方案供應商。我們提供一站式區塊鏈方案，致力助不同的企業通過創新區塊鏈技術進一步發展業務， 從 Web 2.0 向 Web 3.0 的新時代邁進。",
  
      roleColumn1: "基礎建設",
      roleroleColumn1Text1: "區塊鏈即服務（BaaS）",
      roleroleColumn1Text2: "私鏈、公鏈、混合鏈",
      roleroleColumn1Text3: "RPC節點託管服務",
      roleroleColumn1Text4: "區塊鏈驗證人及節點託管",
  
      roleColumn2: "區塊鏈開發",
      roleroleColumn2Text1: "去中心化金融（DeFi）方案",
      roleroleColumn2Text2: "遊戲化金融（GameFi）方案",
      roleroleColumn2Text3: "NFT開發及交易市場方案",
      roleroleColumn2Text4: "智能合約開發",
  
      roleColumn3: "區塊鏈安全",
      roleroleColumn3Text1: "一站式企業方案",
      roleroleColumn3Text2: "智能合約審計",
      roleroleColumn3Text3: "定期安全評估",
  
      baasTitle: "在可靠安全的環境中構建你的區塊鏈生態系統、網絡和dApps",
      baasSubTitle: "我們擁有強大的網絡和企業級基礎設施，讓你能以最少的資源投資實現你所想。",
      baasAdvantage1: "支援跨鏈的基礎設施",
      baasAdvantage2: "支援多條區塊鏈",
      baasAdvantage3: "99.99% 在線保證",
      baasAdvantage4: "金融級別網絡安全（Tier III數據中心）",
      baasAdvantage5: "低延遲",
      baasTag1: "私鏈、公鏈、混合鏈",
      baasTag2: "區塊鏈節點託管",
      baasTag3: "RPC節點託管服務",
      serviceBtnTxext: "服務查詢",
  
      defiTitle: "去中心化金融（DeFi）方案",
      defiSubTitle: "利用多種DeFi方案，進入Web3金融業",
      defiDes: "透過雲呈各種DeFi方案運用區塊鏈及Web3技術，為客戶提供去中心化金融服務，以更快更有效的方式滿足各方面的金融服務需要。",
      defiLi1: "流動性挖礦, 質押智能合約",
      defiLi2: "NFT抵押平台, 槓桿智能合約",
      defiLi3: "ICO、加密貨幣及NFT發射平台",
      defiLi4: "代幣交換網絡, 代幣跨鏈橋",
      defiLi5: "基礎建設及網絡安全",
  
      gameTitle: "遊戲化金融（GameFi）方案",
      gameSubTitle: "開發你的X-to-Earn模型，進入Web3遊戲業",
      gameDes: "雲呈為你提供所有區塊鏈技術及經濟模型方面的支援，讓你專注於遊戲體驗開發。",
      gameLi1: "商業及經濟模型",
      gameLi2: "遊戲資產",
      gameLi3: "遊戲代幣",
      gameLi4: "NFT交易市場",
      gameLi5: "基礎建設",
      gameLi6: "網絡安全",
  
      nftTitle: "NFT 方案",
      nftColumn1: "NFT交易市場",
      nftColumn2: "重新包裝產品",
      nftColumn3: "為會員身分證",
      nftColumn4: "品牌和市場推廣工具",
      price: "查看價格",
  
      securityTitle: "區塊鏈安全方案",
      securitySubTitle: "全天候區塊鏈安全服務– 針對基於區塊鏈的應用程式，涵蓋所有技術層",
      securityDes: "我們為不同規模和行業的企業提供區塊鏈網絡安全管理服務。我們的區塊鏈及安全專家團隊為各種建基於區塊鏈的應用提供全面的安全評估，由設計、創建到執行切合你業務需求的區塊鏈安全策略和評估測試，防止各種因漏洞造成的損失。",
      securityLi1: "區塊鏈安全方案",
      securityLi2: "智能合約審計",
      securityLi3: "前端應用程式碼審查",
      securityLi4: "定期弱點掃描",
      securityLi5: "滲透測試",
      securityBtnText: "區塊鏈安全方案",
  
      domainTitle: "區塊鏈及加密貨幣域名",
      domainSubTitle: "獲取去中心化身份，為你的錢包、網站及分散式應用程式（dApp）註冊區塊鏈及加密貨幣域名",
      domainDes: "使用區塊鏈域名簡化加密貨幣交易及建立你的去中心化網站。以一個簡單易記的域名綁定你的錢包、網站及分散式應用程式，不必再複製和貼上長地址。",
      domainBtnText: "搜尋區塊鏈域名",
  
      paymentTitle: "區塊鏈及加密貨幣支付平台",
      paymentSubTitle: "單一支付平台，支援所有電子支付方式，包括比特幣等加密貨幣",
      paymentDes: "企業可透過我們的商用區塊鏈錢包接受客戶的加密貨幣付款，並轉移到傳統貨幣或冷錢包。除了支援最普及的加密貨幣—比特幣，我們亦支援其他加密貨幣，如以太幣和USDT等。",
      paymentBtnText: "查看價格",
  
    },
  
  
    about: {
      text: "關於雲呈",
      slogan: "區塊在握，鏈接未來",
      introduction: "雲呈 是香港領先區塊鏈及網絡安全方案供應商，我們的專家團隊提供區塊鏈、NFT、元宇宙及加密貨幣等諮詢服務及一站式解決方案，致力助不同的企業通過創新區塊鏈技術進一步發展業務。 雲呈與你並肩同行，從 Web 2.0 向 Web 3.0 的新時代邁進。",
  
      baasTitle: "你值得信賴的區塊鏈即服務（BaaS）供應商",
      baasSubTitle: "雲呈作為一家值得客戶信賴的區塊鏈即服務（BaaS）供應商，我們具備強大的網絡和完善的基建來支持我們客戶的區塊鏈項目，使你能以最少的資源和投資投入實現業務目標。",
  
      servicesTitle: "雲呈服務",
      servicesText1: "區塊鏈基礎建設",
      servicesText2: "區塊鏈開發",
      servicesText3: "區塊鏈安全",
      servicesText4: "雲及網絡安全服務",
  
      advantagesTitle: "雲呈優勢",
      advantagesItem1Title: "貼心服務",
      advantagesItem1SubTitle: "我們將服務質量放在首位",
      advantagesItem1Text: "我們擁抱創新。憑著我們在 Web2 及Web3 技術及營運方面的專業知識提供端對端的方案；配合24/7三語技術支援，助你解決任何規模的難題。",
  
      advantagesItem2Title: "網絡安全",
      advantagesItem2SubTitle: "我們保護你免受任何網絡攻擊",
      advantagesItem2Text: "雲呈獲高度認可獎項及認證的白帽黑客團隊為你的業務護航，提供全面的鏈上和鏈下保護，涵蓋共識、網絡、系統、用戶和應用層。",
  
      advantagesItem3Title: "基礎建設",
      advantagesItem3SubTitle: "我們連接至頂級數據中心以保護你在世界各地的數據",
      advantagesItem3Text: "我們提供由企業級基礎設施支援的雲端和區塊鏈解決方案，並有 99.99% 在線保證。雲呈 擁有 20+ 年的經驗，一直致力為客戶提供高性能、穩定及安全的伺服器和託管服務。",
  
      advantagesItem4Title: "強大網絡",
      advantagesItem4SubTitle: "我們建立強大網絡讓你以最快的速度連接客戶",
      advantagesItem4Text: "雲呈自置超過100Gb+的本地帶寬直達香港國際互聯網交換中心（HKIX），更備CN2高質量中港線路、CDN 及環球帶寬，讓你以高速、可靠穩定的網絡連繫香港、內地以至全球各地，運行中心化及去中心化的應用程式。",
  
      teamTitle: "我們的團隊",
      teamText: "由 雲呈 創辦人、資深加密貨幣投資者章涛帶領的專家團隊，不僅掌握最新區塊鏈技術和加密貨幣投資知識，更擁有實行不同規模的區塊鏈項目的豐富經驗，為客戶訂製最適合可行的方案，由 Web2 轉型到 Web3。",
      
      storyTitle: "雲呈 品牌故事",
      story: "成立於1998年，雲呈早期以提供域名註冊、網頁寄存等雲服務為主，及後逐漸發展成雲管理、網絡方案及網絡安全管理服務供應商。自2017年起，我們開拓區塊鏈業務，為 客戶提供區塊鏈、NFT及加密貨幣服務。我們的客戶涵蓋香港、台灣、內地等大中華地區。逾20年來，我們不斷成長，力求創新，成為香港領先科技公司。",
  
      partner: "雲呈 合作夥伴",
      customer: "雲呈 客戶",
  
      it: "IT經驗",
      kehu: "客戶滿布全球",
      qukuaijy: "區塊鏈經驗",
      kaifa: "開發人員及工程師",
      qukuaikf: "區塊鏈開發",
      jishuzy: "技術支援",
      zaixian: "在線保證",
      fuwuqi: "伺服器於頂級數據中心",
      hwcdn: "中國及海外CDN寬帶",
      bdcdn: "本地CDN帶寬",

    
    },
  
  
    news: {
      text: "雲呈",
      slogan: "專業文章及見解，揭示科技領域的一切",
      latest: "最新",
      latestDes: "歡迎來到 雲呈！隨時關注我們的分析文章、消息更新、優惠推廣和新聞稿。",
  
      strategyDes: "緊貼有關區塊鏈、網絡安全等創新科技的最新趨勢和資訊。",
      caseDes: "從我們客戶的成功故事中獲取靈感，了解 雲呈 如何與客戶並肩走過這段旅程。",
      insightDes: "雲呈區塊鏈和網絡安全專家為你帶來獨到分析和見解。",
      financeDes: "作為香港領先區塊鏈及網絡安全方案供應商，由緊貼區塊鏈市場最新消息KOL為你帶來獨到分析和見解。",
      columnDes: "由參與、見證眾多區塊鏈商業應用落地的雲呈行政總裁跟你分享其對區塊鏈發展個人分析及看法！",
  
    },
  
    subscribe: {
      text:"訂閱",
      contnet:"獲取最新的區塊鏈、加密貨幣及數字資產資訊，了解全球市場動向，萬勿錯過！",
      email:"電郵地址",
    },
  
    footer: {
      title:"區塊在握 鏈接未來",
      contactUs:"聯絡我們",
      payment:"付款方法",
      service:"服務協議",
      privacy:"私隱條款",
      
    },
  
    toast: {
  
    },
  
  }